import {format} from 'date-fns'

const emptySaHelpResponse = {
  austPartStudy: null,
  austResStudy: null,
  campus: '',
  citizenship: '',
  courseCd: '',
  courseName: '',
  dob: '',
  firstName: '',
  gender: '',
  institution: '',
  lastName: '',
  lastUpdate: {
    date: '',
  },
  nZVisaCriteria: null,
  nZVisaIndicator: null,
  studentId: '',
  taxFileCertificate: '',
  taxFileNumberExists: '',

  // This flag doesn't exist in the SA-HELP API
  fullUpFrontPayment: ''
}

const calculateTaxFileCertificateEligibility = saHelpDetails => {
  if (saHelpDetails.taxFileNumberExists === 'Y') {
    return 'N'
  }
  return saHelpDetails.taxFileCertificate
}

/**
 * The fullUpFrontPayment flag doesn't exist in the SA-HELP API so we need
 * to pretend that it exists
 */
const calculateFullUpFrontPayment = (saHelpDetails, originalEcafDetails) => {
  if (saHelpDetails.lastUpdate.date) {
    return 'N'
  }

  if (originalEcafDetails.lastUpdate.date) {
    return 'Y'
  }

  return null
}

export default (
  state = {
    isFetching: true,
    originalData: emptySaHelpResponse,
    updatedData: emptySaHelpResponse,
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_SA_HELP_DETAILS':
      return {
        ...state,
        isFetching: true,
        originalData: emptySaHelpResponse,
        updatedData: emptySaHelpResponse,
      }
    case 'RECEIVE_SA_HELP_DETAILS':
      const saHelpDetails = {
        ...action.saHelpDetails,
        fullUpFrontPayment: calculateFullUpFrontPayment(action.saHelpDetails, action.originalEcafDetails),
        taxFileCertificate: calculateTaxFileCertificateEligibility(action.saHelpDetails),
      }

      return {
        ...state,
        isFetching: false,
        originalData: saHelpDetails,
        updatedData: saHelpDetails,
      }
    case 'RECEIVE_SA_HELP_DETAILS_FAILED':
      return {
        ...state,
        isFetching: false,
        originalData: emptySaHelpResponse,
        updatedData: emptySaHelpResponse,
      }
    case 'UPDATE_SA_HELP_FULL_UPFRONT_PAYMENT':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          fullUpFrontPayment: action.fullUpFrontPayment,
        },
      }
    case 'SAVE_SA_HELP_FORM':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          ...action.updatedFields,
          lastUpdate: {
            ...state.updatedData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          }
        },
      }
    case 'SUBMIT_SA_HELP_DETAILS':
      const updatedSaHelpDetails = {
        ...action.updatedSaHelpDetails,
        fullUpFrontPayment: calculateFullUpFrontPayment(action.updatedSaHelpDetails, action.originalEcafDetails),
        taxFileCertificate: calculateTaxFileCertificateEligibility(action.updatedSaHelpDetails),
      }

      return {
        ...state,
        isFetching: false,
        originalData: updatedSaHelpDetails,
        updatedData: updatedSaHelpDetails,
      }
    case 'SUBMIT_ECAF_DETAILS_ALREADY_SUBMITTED':
      return {
        ...state,
        originalData: {
          ...state.originalData,
          lastUpdate: {
            ...state.originalData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          }
        },
        updatedData: {
          ...state.updatedData,
          lastUpdate: {
            ...state.updatedData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          }
        },
      }
    default:
      return state
  }
}
